import * as classnames from 'classnames'
import * as React from 'react'
import { compose, pure } from 'recompose'

import { ChoiceIndex } from '../../../../commons/ChoiceIndex'
import { ChoiceStatus } from '../../../../commons/ChoiceStatus'
import { QuestionType } from '../../../../commons/EditorStatus'
import QuestionChoiceImage from '../../molecules/QuestionChoiceImage/QuestionChoiceImage'
import QuestionChoiceText from '../../molecules/QuestionChoiceText/QuestionChoiceText'
import QuestionChoiceTrueFalse from '../../molecules/QuestionChoiceTrueFalse/QuestionChoiceTrueFalse'
import * as styles from './QuestionChoice.css'

interface QuestionChoiceProps {
  type?: number
  children?: string
  src?: string
  answerCount?: number
  totalAnswerCount?: number
  isMaru: boolean
  choiceStatus: ChoiceStatus
  index: number
}

const QuestionChoice: React.FunctionComponent<QuestionChoiceProps> = ({
  type = QuestionType.FOURCHOICE.value,
  children,
  src,
  isMaru,
  answerCount,
  totalAnswerCount,
  choiceStatus,
  index
}) => {
  let renderDOM: React.ReactElement<any> = <div />
  const whiteTextColor = choiceStatus === ChoiceStatus.CORRECT

  switch (type) {
    case QuestionType.FOURCHOICE.value:
    case QuestionType.REALTIME.value:
      if (src) {
        renderDOM = (
          <QuestionChoiceImage
            src={src}
            label={ChoiceIndex[index]}
            answerCount={answerCount}
            white={whiteTextColor}
            totalAnswerCount={totalAnswerCount}
          >
            {children || ''}
          </QuestionChoiceImage>
        )
      } else {
        renderDOM = (
          <QuestionChoiceText
            label={ChoiceIndex[index]}
            white={whiteTextColor}
            answerCount={answerCount}
            totalAnswerCount={totalAnswerCount}
          >
            {children || ''}
          </QuestionChoiceText>
        )
      }
      break

    default:
      renderDOM = (
        <QuestionChoiceTrueFalse
          isMaru={isMaru}
          answerCount={answerCount}
          white={whiteTextColor}
          totalAnswerCount={totalAnswerCount}
        />
      )
  }

  let buttonClass = ''

  switch (choiceStatus) {
    case ChoiceStatus.NORMAL:
      buttonClass = styles.normal
      break

    case ChoiceStatus.CORRECT:
      buttonClass = styles.correct
      break

    case ChoiceStatus.TRANSPARENT:
      buttonClass = styles.transparent
      break
  }

  return <div className={classnames(styles.button, buttonClass)}>{renderDOM}</div>
}

export default compose<QuestionChoiceProps, QuestionChoiceProps>(pure)(QuestionChoice)
